import React from "react";
import { connect } from "react-redux";
import 'react-select/dist/react-select.css';
import { get } from "lodash";
import Select from "react-select";

import * as authSelectors from "../../redux/auth/selectors";
import * as projectSelectors from '../../redux/projects/selectors'
import * as checklistSelectors from '../../redux/checklists/selectors'

import {
  setProjectId
} from "../../redux/checklists/actions";

export const DEFAULT_SELECT_OPTION = { key: 'PRIVATE', label: 'Private' };

class ProjectSelect extends React.Component {

  componentDidMount() {
    const { setProjectId, checklistProjectId, userId, projectsList, history } = this.props;
    const { location } = history;

    const pathName = this.getPathName(location);

    // if (pathName !== 'checklist' && pathName === 'undefined') {
    //   const projectId = (checklistProjectId && checklistProjectId !== 'PRIVATE') ? checklistProjectId : Object.keys(projectsList)[0];
    //   const project = projectsList[projectId];
    //   const isProjectOwner = get(project, 'owner.id') === userId;
    //
    //   history.push(`${projectId}`);
    //   setProjectId(projectId, isProjectOwner);
    // }
    //
    // if (pathName === 'plans') {
    //   const projectId = (checklistProjectId && checklistProjectId !== 'PRIVATE') ? checklistProjectId : Object.keys(projectsList)[0];
    //   const project = projectsList[projectId];
    //   const isProjectOwner = get(project, 'owner.id') === userId;
    //
    //   history.push(`${projectId}`);
    //   setProjectId(projectId, isProjectOwner);
    // }
    //
    // if (pathName === 'settings') {
    //   const projectId = (checklistProjectId && checklistProjectId !== 'PRIVATE') ? checklistProjectId : Object.keys(projectsList)[0];
    //   const project = projectsList[projectId];
    //   const isProjectOwner = get(project, 'owner.id') === userId;
    //
    //   history.push(`${projectId}`);
    //   setProjectId(projectId, isProjectOwner);
    // }
    //
    // if (pathName === 'files') {
    //   const projectId = (checklistProjectId && checklistProjectId !== 'PRIVATE') ? checklistProjectId : Object.keys(projectsList)[0];
    //   const project = projectsList[projectId];
    //   const isProjectOwner = get(project, 'owner.id') === userId;
    //
    //   history.push(`${projectId}`);
    //   setProjectId(projectId, isProjectOwner);
    // }
  }

  handleChange = (value) => {
    const { setProjectId, checklistProjectId, userId, projectsList, history } = this.props;
    const { location } = history;

    if (!value) {
      return;
    }

    if (!value.key) {
      return;
    }

    if (checklistProjectId !== value.key) {

      let isProjectOwner = false;

      if (value.key === 'PRIVATE') {
        isProjectOwner = true
      } else {
        const project = projectsList[value.key];

        isProjectOwner = get(project, 'owner.id') === userId;

        if (!isProjectOwner) {
          const allowMembersToChangeChecklists = get(project, 'allowMembersToChangeChecklists');

          if (allowMembersToChangeChecklists) {
            isProjectOwner = true;
          }
        }
      }

      const pathName = this.getPathName(location);

      if (pathName === 'plans' || pathName === 'settings' || pathName === 'files') {
        // history.push(`${checklistProjectId}`);
      }

      setProjectId(value.key, isProjectOwner);
    }
  };

  getPathName(location) {
    const { pathname } = location;
    const locationPath = pathname.split('/');

    return locationPath[ locationPath.length - 1 ];
  }

  get options() {
    const { projectsList, history } = this.props;
    const { location } = history;

    const pathName = this.getPathName(location);
    const options = pathName === 'checklist' ? [DEFAULT_SELECT_OPTION] : [];
    // const options = [DEFAULT_SELECT_OPTION];

    Object.values(projectsList).forEach(project => {
      if (!project.id) {
        return;
      }

      const option = {
        key: project.id,
        label: project.title,
        ownerId: get(project, 'owner.id')
      };

      options.push(option);
    });

    return options;
  };

  renderOwnProjectBold = option => {
    const { userId } = this.props;

    return (
      <span
        style={{
          fontWeight: option.key === 'PRIVATE' || userId === option.ownerId ? '600' : '400'
        }}
      >
        {option.label}
      </span>
    );
  };

  render() {
    const { checklistProjectId, projectsList, isProjectOwner, history } = this.props;
    const { location } = history;

    const pathName = this.getPathName(location);

    let selectedValue =  pathName === 'checklist' ? DEFAULT_SELECT_OPTION : {};

    if (checklistProjectId) {
      if (checklistProjectId === 'PRIVATE') {
        selectedValue = pathName === 'checklist' ? DEFAULT_SELECT_OPTION : {};
      } else {
        const project = projectsList[checklistProjectId];

        if (project){
          selectedValue = { key: project.id, label: project.title };
        }
      }

      // if (checklistProjectId === 'PRIVATE' && pathName === 'checklist') {
      //   selectedValue = DEFAULT_SELECT_OPTION;
      // } else {
      //   const project = checklistProjectId ? projectsList[checklistProjectId] : projectsList[(Object.keys(projectsList)[0])];
      //
      //   if (project) {
      //     selectedValue = {key: project.id, label: project.title};
      //   }
      // }
      //
      // if (checklistProjectId === 'PRIVATE' && pathName !== 'checklist') {
      //   const project = projectsList[(Object.keys(projectsList)[0])];
      //
      //   selectedValue = { key: project.id, label: project.title };
      // }
    }

    return (
      <div
        style={{
          position: "fixed",
          top: 8,
          left: 150,
          zIndex: 1300,
          width: 600,
          display: 'flex'
        }}
      >
        <div style={{width: 180, minWidth: 180}}>
          <div
            style={{
              marginBottom: "5px",
              color: 'rgba(0, 0, 0, 0.54)',
            }}
          >
            Choose project
          </div>
          <Select
            className="select-project"
            clearable={false}
            autosize={false}
            onBlurResetsInput={false}
            // arrowRenderer={() => null}
            options={this.options}
            valueKey="label"
            placeholder="Select project"
            onChange={this.handleChange}
            value={selectedValue}
            optionRenderer={this.renderOwnProjectBold}
            // valueRenderer={this.renderCountryValue}
            matchProp="any"
          />
        </div>
        <div style={{
          marginLeft: 10,
          marginTop: 32,
          color: 'rgba(0, 0, 0, 0.54)',
        }}>
          {isProjectOwner ? 'You can select projects from the dropdown' : '' }
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    userId: authSelectors.getUserId(state),
    projectsList: projectSelectors.projectsList(state),
    checklistProjectId: checklistSelectors.checklistProjectId(state),
    isProjectOwner: checklistSelectors.isProjectOwner(state),
  }),
  {
    setProjectId
  }
)(ProjectSelect);
